import { Recipe, RecipeDetailsResponse, RecipeShareParameter } from '../model';

// This file contains constants used throughout the application.
const CONSTANTS_DETAILS_CONFIG = {
  APP_NAME: 'Total Cost-in-Use (TCIU) Calculator',
  MESSAGE_SHOW_TIME: 5,
  APP_DEAULT_LANGUAGE: 'en',
  APP_MENUS: [
    {
      label: 'newRecipe',
      link: null,
      icon: 'add_to_photos',
      isDevider: false,
      privilege: ['REC_CREATE_NEW'],
      children: [
        {
          icon: 'library_add',
          label: 'createNewRecipe',
          action: 'createNewRecipe',
          link: null,
        },
        {
          icon: 'flip_to_front',
          label: 'createExistingRecipe',
          action: 'createExistingRecipe',
          link: '/recipe/create-existing',
        },
      ],
    },
    {
      label: 'draftRecipe',
      link: '/recipe/draft',
      icon: 'library_books',
      isDevider: false,
      privilege: ['REC_ACCESS_DRAFT_LISTING'],
    },
    {
      label: 'finalRecipe',
      link: '/recipe/final',
      icon: 'library_add_check',
      isDevider: true,
      privilege: ['REC_ACCESS_FINAL_LISTING'],
    },
    {
      label: 'ingredientLibrary',
      link: '/',
      icon: 'book',
      isDevider: false,
      privilege: [],
      children: [
        {
          icon: 'update',
          label: 'nutritionalInformation',
          action: 'nutritionalInformation',
          link: '/library/nutritional-information',
        },
        {
          icon: 'price_change',
          label: 'updatePrice',
          action: 'updatePrice',
          link: '/library/update-price-asp',
        },
        {
          icon: 'account_tree',
          label: 'ingredientFamilyMapping',
          action: 'ingredientFamilyMapping',
          link: '/library/ingredient-family-mapping',
        },
      ],
    },
    {
      label: 'newIngredient',
      link: null,
      icon: 'filter_tilt_shift',
      isDevider: false,
      privilege: ['INGR_ADD_CUSTOM'],
    },
    {
      label: 'settings',
      link: null,
      icon: 'settings',
      isDevider: false,
      privilege: [],
      children: [
        {
          icon: 'shield_locked',
          label: 'roleMatrix',
          action: 'roleMatrix',
          link: '/setting/role-matrix',
        },
        {
          icon: 'currency_exchange',
          label: 'currencyExchangeRateManager',
          action: 'currencyExchangeRateManager',
          link: '/setting/currency-exchange-rate-manager',
        },
        {
          icon: 'payments',
          label: 'defaultCurrencyUOM',
          action: 'defaultCurrencyUOM',
          link: '/setting/uom-currency',
        },
        {
          icon: 'find_replace',
          label: 'manageLookup',
          action: 'manageLookup',
          link: '/setting/manage-lookup',
        },
        {
          icon: 'dashboard',
          label: 'kpiDashboard',
          action: 'kpiDashboard',
          link: '/setting/kpi-dashboard',
        },
        {
          icon: 'group',
          label: 'configurePricingAdmin',
          action: 'configurePricingAdmin',
          link: '/setting/configure-pricing-admins',
        },
      ],
    },
  ],
  PAGE_SIZE_OPTIONS: [9, 18, 27],
  DEFAULT_PAGE_SIZE: 9,
  DATE_FORMAT: 'MM/dd/yyyy',
  DATE_TIME_FORMAT: 'MM/dd/yyyy hh:mm a',
  DRAFT_RECIPE_BASE_URL: '/Recipe/search-recipes',
  INGREDIENT_BASE_URL: '/Ingredient',
  CREATE_CUSTOM_INGREDIENT_URL: '/create-ingredient',
  FAMILY_BASE_URL: '/Family/family-master',
  INGREDIENT_TYPE_URL: '/get-ingredient-type-master',
  INGREDIENT_NUTRITIONAL_INFO_URL: '/get-ingredients-nutritional-info',
  INGREDIENT_NUTRITIONAL_INFO_HISTORY_URL: '/nutrition-info-history',
  SEARCH_INGREDIENT_NAME_URL: '/search-ingredients-by-name',
  SEARCH_INGREDIENT_NAME_FAMILY_URL:
    '/search-recipe-ingredients-family-by-name',
  SEND_UPDATE_ASP_REQUEST: '/send-ingredient-asp-request-Email',
  RECIPE_BASE_URL: '/Recipe',
  CREATE_RECIPE_URL: '/create-recipe',
  RECIPE_DETAILS_BASE_URL: '/Recipe/recipe-details',
  SAVE_RECIPE_DETAILS_URL: '/save-recipe-details',
  CREATE_RECIPE_PROTOTYPE_URL: '/add-new-prototype',
  UPDATE_RECIPE_NAME_URL: '/rename-draft-recipe',
  UPDATE_RECIPE_VARIANT_NAME_URL: '/rename-recipe-variant',
  UPDATE_VARIANT_TO_CONTROL_NAME_URL: '/update-variant-to-control',
  DELETE_RECIPE_INGREDIENT_URL: '/delete-recipe-ingredient',
  DELETE_RECIPE_VARIANT_URL: '/delete-recipe-variant',
  GET_RECIPE_ACCESSORS_URL: '/recipe-accessor-list',
  UPDATE_RECIPE_ACCESSORS_URL: '/update-recipe-accessor-privilege',
  DELETE_RECIPE_ACCESSORS_URL: '/delete-recipe-accessor',
  VARIANT_ATTACHMENTS_URL: '/get-variant-attachments-list',
  DOWNLOAD_VARIANT_ATTACHMENT_URL: '/download-variant-attachment',
  HISTORY_PPT_URL: '/get-historic-ppt-list',
  DOWNLOAD_HISTORY_PPT_URL: '/download-historic-ppt',
  CATEGORY_BASE_URL: '/Category/category-master',
  COUNTRY_BASE_URL: '/Country/country-master',
  REGION_BASE_URL: '/Region/region-master',
  CURRENCY_BASE_URL: '/Currency/currency-master',
  CURRENCY_EXCHANGE_RATE_BASE_URL: '/Currency/currency-exchange-rate-master',
  CURRENCY_EXCHANGE_HISTORY_URL: '/Currency/currency-exchange-rate-history',
  CURRENCY_EXCHANGE_UPDATE_URL: '/Currency/update-exchange-rate-manager',
  CURRENCY_EXCHANGE_CREATE_URL: '/Currency/create-exchange-rate-manager',
  ROLES_PRIVILEGES_FETCH_URL:
    '/RolesPrivilege/fetch-app-role-privileges-details',
  ROLES_PRIVILEGES_UPDATE_URL:
    '/RolesPrivilege/update-app-role-privileges-details',
  ADD_NEW_RECIPE_COMMENT_URL: '/add-recipe-comment',
  ADD_NEW_VARIANT_COMMENT_URL: '/add-variant-recipe-comment',
  PUBLISH_RECIPE_URL: '/publish-final-recipe',
  FETCH_COMMENTS_URL: '/fetch-comments',
  APP_MENU_LABELS: {
    NEW_RECIPE: 'New Recipe',
    NEW_INGREDIENT: 'New Ingredient',
    NEW_INGREDIENT_MENU_LABEL: 'newIngredient',
    INGREDIENT_ID_PLACEHOLDER: 'Enter Ingredient ID Here',
    INGREDIENT_NAME_PLACEHOLDER: 'Enter Ingredient Name Here',
    INGREDIENT_TYPE_PLACEHOLDER: 'Select Ingredient Type',
    INGREDIENT_FAMILY_PLACEHOLDER: 'Select Family',
    INGREDIENT_LIBRARY: 'Ingredient Library',
    SETTINGS: 'Settings',
  },
  ADVANCED_SEARCH_PARAM_API:
    '/Metadata/advanced-search-properties?className=recipesadvancedsearch',
  BASE_URL_REGION: '/Region/region-master',
  BASE_URL_COUNTRY: '/Country/country-master',
  BASE_URL_CATEGORY: '/Category/category-master',
  BASE_URL_ENABLE_DISABLE_REGION: '/Region/enable-disable-region',
  BASE_URL_GET_REGIONWISE_PRICING_ADMINS:
    '/Region/regionwise-pricing-admins-list',
  ADD_REGIONWISE_PRICING_ADMIN: '/Region/add-region-approver',
  DELETE_REGIONWISE_PRICING_ADMIN: '/Region/delete-region-approver',
  BASE_URL_ENABLE_DIABLE_COUNTRY: '/Country/enable-disable-country',
  BASE_URL_ENABLE_DISABLE_CATEGORY: '/Category/enable-disable-category',
  PROJECT_LIST_URL: '/Metadata/get-project-details',
  LOOKUP_TYPES: [
    {
      label: 'Category',
      value: 'Category',
      BASE_URL: '/Category/category-master',
      BASE_URL_ENABLE_DISABLE: '/Category/enable-disable-category',
    },
    {
      label: 'Country',
      value: 'Country',
      BASE_URL: '/Country/country-master',
      BASE_URL_ENABLE_DISABLE: '/Country/enable-disable-country',
    },
    {
      label: 'Currency',
      value: 'Currency',
      BASE_URL: '/Currency/currency-master',
      BASE_URL_ENABLE_DISABLE: '/Currency/enable-disable-currency',
    },
    {
      label: 'Family',
      value: 'Family',
      BASE_URL: '/Family/family-master',
      BASE_URL_ENABLE_DISABLE: '/Family/enable-disable-family',
    },
    {
      label: 'Ingredient Type',
      value: 'IngredientType',
      BASE_URL: '/Ingredient/get-ingredient-type-master',
      BASE_URL_ENABLE_DISABLE: '/Ingredient/enable-disable-ingredient-type',
    },
    {
      label: 'Region',
      value: 'Region',
      BASE_URL: '/Region/region-master',
      BASE_URL_ENABLE_DISABLE: '/Region/enable-disable-region',
    },
    {
      label: 'UOM',
      value: 'UOM',
      BASE_URL: '/UOM/uom-master',
      BASE_URL_ENABLE_DISABLE: '/UOM/enable-disable-uom',
    },
  ],
  INGREDIENT_FAMILY_MAPPING_URL: '/get-ingredient-master',
  UPDATE_INGREDIENT_FAMILY_MAPPING_URL: '/update-ingredient-family-master',
  UPDATE_INGREDIENT_NUTRITIONAL_INFO_URL: '/update-ingredient-nutritional-info',
  UPDATE_INGREDIENT_ASP_MASTER_URL: '/update-ingredient-asp-master',
  INGREDIENT_ASP_CURRENT_PRICE: '/ingredient-asp-current-price',
  INGREDIENT_ASP_PRICE_HISTORY: '/ingredient-asp-price-history',
  INGREDIENT_ASP: 'Update Price ASP',
  CURRENCY_EXCHANGE_RATE_MANAGER: 'Currency Exchange Rate Manager',
  CREATE_FROM_EXISTING_RECIPES: '/new-recipe-from-existing',
  RECIPE_REPORT: '/Recipe/recipe-activity-report',
  DOWLOAD_EXCEL_REPORT: '/Recipe/export-recipe-activity-report',
  GET_USERPRIVILEGES_URL: '/RolesPrivilege/fetch-user-role-privileges-details',
  GET_CATEGORY_OWNERS: '/User/get-all-category-owners',
  DEFAULT_CURRENCY_CODE: {
    currencyCode: 'USD',
  },
  SHARE_RECIPE_URL: '/Recipe/share-recipe',
  CURRENCY_UOM_REGION_COUNTRY_MASTER_URLS: {
    UOM: '/UOM/uom-master',
    REGION: '/Region/region-master',
    COUNTRY: '/Country/country-master',
    CURRENCY: '/Currency/currency-master',
  },
  DEFAULT_CURRENCY_UOM_MAPPER_URL: '/Currency/geo-commerce-mapper-master',
  CREATE_UOM_CURRENCY_MAPPER_URL: '/Currency/create-geo-commerce-mapper',
  UPDATE_UOM_CURRENCY_MAPPER_URL: '/Currency/update-geo-commerce-mapper',
  SVG_PERCENTAGE_PATH:
    'M300-520q-58 0-99-41t-41-99q0-58 41-99t99-41q58 0 99 41t41 99q0 58-41 99t-99 41Zm0-80q25 0 42.5-17.5T360-660q0-25-17.5-42.5T300-720q-25 0-42.5 17.5T240-660q0 25 17.5 42.5T300-600Zm360 440q-58 0-99-41t-41-99q0-58 41-99t99-41q58 0 99 41t41 99q0 58-41 99t-99 41Zm0-80q25 0 42.5-17.5T720-300q0-25-17.5-42.5T660-360q-25 0-42.5 17.5T600-300q0 25 17.5 42.5T660-240Zm-444 80-56-56 584-584 56 56-584 584Z',
  SVG_DOLLAR_PATH:
    'M441-120v-86q-53-12-91.5-46T293-348l74-30q15 48 44.5 73t77.5 25q41 0 69.5-18.5T587-356q0-35-22-55.5T463-458q-86-27-118-64.5T313-614q0-65 42-101t86-41v-84h80v84q50 8 82.5 36.5T651-650l-74 32q-12-32-34-48t-60-16q-44 0-67 19.5T393-614q0 33 30 52t104 40q69 20 104.5 63.5T667-358q0 71-42 108t-104 46v84h-80Z',
  recipeMenuItems: [
    /* "id" should be the method name of the icon functionality */
    {
      id: 'shareRecipeDialog',
      label: 'share',
      icon: 'send',
      show: (
        recipe?: Recipe | RecipeDetailsResponse | RecipeShareParameter | null,
        loggedInUserMailId?: string,
      ) => {
        if (!recipe) return false;
        if (
          recipe.isPrivate &&
          recipe.createdBy !== loggedInUserMailId &&
          recipe.isFinal &&
          recipe.isReadOnly
        ) {
          return false;
        } else if (
          recipe.isPrivate &&
          recipe.createdBy !== loggedInUserMailId &&
          !recipe.isFinal &&
          !recipe.isReadOnly
        ) {
          return true;
        } else if (
          recipe.isPrivate &&
          recipe.createdBy !== loggedInUserMailId &&
          !recipe.isFinal
        ) {
          return false;
        } else {
          return true;
        }
      },
      disabled: false,
      allowedIn: ['draft', 'details'],
      privilege: ['REC_SHARE'],
    },
    {
      id: 'createCopy',
      label: 'createCopy',
      icon: 'flip_to_front',
      show: () => true,
      disabled: false,
      allowedIn: ['draft'],
      privilege: ['REC_COPY'],
    },
    {
      id: 'openCommentsBox',
      label: 'addComment',
      labelWhenFinal: 'viewComment',
      icon: 'comment',
      show: () => true,
      disabled: false,
      allowedIn: ['details'],
    },
    {
      id: 'downloadRecipeDialog',
      label: 'downloadPresentation',
      icon: 'download',
      show: () => true,
      disabled: false,
      allowedIn: ['details'],
    },
    {
      id: 'publishAsFinal',
      label: 'publishAsFinal',
      icon: 'library_add_check',
      show: (
        recipe: Recipe | RecipeDetailsResponse | RecipeShareParameter | null,
      ) => !recipe?.isFinal,
      disabled: false,
      allowedIn: ['details'],
    },
  ],
  GET_VARIANT_ATTACHMENTS_URL: '/Recipe/get-variant-attachments-list?',
  UPDATE_VARIANT_ATTACHMENTS_URL: '/Recipe/upload-variant-attachment',
  EXPORT_VARIANT_PPTX_URL: '/Recipe/export-variant-to-pptx',
  ALLOWED_FILE_TYPES: [
    /*Images*/
    'jpg',
    'jpeg',
    'png',
    'gif',
    'bmp',
    'webp',
    'svg',
    /* pdf */
    'pdf',
    /* MS Office Doc's */
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
  ],
  GET_AG_GRID_KEY: '/Metadata/get-aggrid-key',
  GET_TRANSLATION: '/Metadata/get-translation-tokens',
  DEBOUNCE_TRIGGERS: {
    AUTOSAVE_DEBOUNCE_TIME: 60000,
    INGREDIENT_SEARCH_DEBOUNCE_TIME: 1000,
  },
  CONTROLLED_ING_TYPE: ['INT-1', 'INT-3', 'INT-5'],
  ADD_INGREDIENT_ASP_URL: '/create-ingredient-asp-region-mapping',
  DASHBOARD_FILTER: [
    {
      label: 'today',
      value: 'today',
    },
    {
      label: 'yesterday',
      value: 'yesterday',
    },
    {
      label: 'week',
      value: 'week',
    },
    {
      label: 'month',
      value: 'month',
    },
    {
      label: 'quarter',
      value: 'quarter',
    },
    {
      label: 'lifeTime',
      value: 'lifeTime',
    },
    {
      label: 'custom',
      value: 'custom',
    },
  ],
  ASP_DECIMAL_PLACES: 3,
};
export const CONSTANTS_DETAILS = Object.freeze(CONSTANTS_DETAILS_CONFIG);
